import ReactGA from "react-ga";

import { envSwitch, isDev } from "@connect/Env";

export default function initGoogleAnalytics() {
	const analyticsID = envSwitch("UA-75275209-5", "UA-75275209-4", "UA-75275209-3");

	ReactGA.initialize(analyticsID, { debug: isDev() });
}